import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { URLSearchParams } from '@angular/http';
import { AgGridHelper } from '../../../util/AgGridHelper';
import * as encoding from 'encoding-japanese';
import { ShipService } from '../../../service/ship/ship.service';
import { DtAddressService } from '../../../service/dt-address/dt-address.service';
import { ShipInvoiceService } from '../../../service/ship-invoice/ship-invoice.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9144.component.html',
  styleUrls: ['wa9144.component.scss']
})
export class Wa9144Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9144:届先マスタ修正（出荷）';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;

  private gridHelper: AgGridHelper;
  @ViewChild('GridView')
  GridView: ElementRef;
  private totalCount = 0;
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  public checkbox: boolean;
  public ownerId: number;
  public searchOwnerId: number;
  public ownerTx: string;
  public ownerResult: any;
  private dspnone: boolean = true;
  public ships: any;
  public shipnoCd: any;
  public ordernoCd: any;
  public carrierTx: any;
  public delirouteTx: any;
  public dtnameTx: string;
  public maDtnameTx: string;
  public shiphId: number;
  public carrierCd: string;
  public dtaddressId: number;
  public dtaddressCd: string;
  public dtpostalCd: string;
  public dttelTx: string;
  public dtaddress1Tx: string;
  public dtaddress2Tx: string;
  public dtaddress3Tx: string;
  public maDtpostalCd: string;
  public maDttelTx: string;
  public maDtaddress1Tx: string;
  public maDtaddress2Tx: string;
  public maDtaddress3Tx: string;
  public delirouteId: number;
  public delirouteCd: string;
  public typeshipinvoiceCd: string;
  public freeItem1Tx: string;
  public freeItem2Tx: string;
  public updcounterNr: number;

  public config = config;

  public working = false;
  public working2 = false;
  public working3 = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public updprogramCd = 'wa9144';
  private errorInfo = '';
  private isEnableClearFilter = false;
  private otherwindow: boolean = false;
  private NodeData: object[] = [];
  private isEnableCreateButton = false;
  private paginationGetRowCount = 0;

  constructor(
    private router: Router,
    private shipService: ShipService,
    private dtAddressService: DtAddressService,
    private shipInvoiceService: ShipInvoiceService,
    private ownerService: OwnerService,
    private commonService: CommonService
  ) {
    this.cardHeight = window.innerHeight - 80;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.working = true;
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      pagination: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9144_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.el.nativeElement.querySelector('.ag-floating-filter-body').style.display = 'block';
        this.gridHelper.el.nativeElement.querySelector('.ag-floating-filter-button').style.display = 'block';

        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '出荷番号',
        headerTooltip: '出荷番号',
        field: 'shipnoCd',
        cellClass: ['bl', 'tl', 'cellclass'],
        unSortIcon: true,
        sort: 'desc',
        pinned: 'left',
        suppressMenu: true,
        width: this.getColumnWidth('shipnoCd', 230),
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '修正',
          itemFieldAfterButton: 'shipnoCd',
          onClick: this.oGridDetailButtonClick.bind(this)
        }
      },
      {
        headerName: '出荷指示日',
        headerTooltip: '出荷指示日',
        field: 'shipDt',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('shipDt', 120)
      },
      {
        headerName: '荷主名',
        headerTooltip: '荷主名',
        field: 'ownerTx',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('ownerTx', 140)
      },
      {
        headerName: '届先・名前',
        headerTooltip: '届先・名前',
        field: 'dtnameTx',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('dtnameTx', 120)
      },
      {
        headerName: '届先コード',
        headerTooltip: '届先コード',
        field: 'dtaddressCd',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('dtaddressCd', 130)
      },
      {
        headerName: '届先・郵便番号',
        headerTooltip: '届先・郵便番号',
        field: 'dtpostalCd',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('dtpostalCd', 120)
      },
      {
        headerName: '届先・住所1',
        headerTooltip: '届先・住所1',
        field: 'dtaddress1Tx',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('dtaddress1Tx', 300)
      },
      {
        headerName: '届先・住所2',
        headerTooltip: '届先・住所2',
        field: 'dtaddress2Tx',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('dtaddress2Tx', 250)
      },
      {
        headerName: '届先・住所3',
        headerTooltip: '届先・住所3',
        field: 'dtaddress3Tx',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('dtaddress3Tx', 200)
      },
      {
        headerName: '届先・電話番号',
        headerTooltip: '届先・電話番号',
        field: 'dttelTx',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('dttelTx', 160)
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    //SessionStorageから荷主Idを取得
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.searchOwnerId = selectedOwner.ownerId;
    }

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight;
    this.gridHeight = 200;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9144_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9144_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9144_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.GridView;
    setTimeout(() => {
      if (this.headerComponent.isLogin === true) {
        this.onSubmit();
      }
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  onView(event) {
    this.ownerId = event ? event.data.ownerId : 0;
    this.ownerTx = event ? event.data.ownerTx : 0;
    this.shiphId = event ? event.data.shiphId : 0;
    this.carrierCd = event ? event.data.maCarrierCd : '';
    this.dtaddressId = event ? event.data.maDtaddressId : 0;
    this.dtaddressCd = event ? event.data.dtaddressCd : '';
    this.dtnameTx = event ? event.data.dtnameTx : '';
    this.maDtnameTx = event ? event.data.maDtnameTx : '';
    this.dtpostalCd = event ? event.data.dtpostalCd : '';
    this.dttelTx = event ? event.data.dttelTx : '';
    this.dtaddress1Tx = event ? event.data.dtaddress1Tx : '';
    this.dtaddress2Tx = event ? event.data.dtaddress2Tx : '';
    this.dtaddress3Tx = event ? event.data.dtaddress3Tx : '';
    this.maDtpostalCd = event ? event.data.maDtpostalCd : '';
    this.maDttelTx = event ? event.data.maDttelTx : '';
    this.maDtaddress1Tx = event ? event.data.maDtaddress1Tx : '';
    this.maDtaddress2Tx = event ? event.data.maDtaddress2Tx : '';
    this.maDtaddress3Tx = event ? event.data.maDtaddress3Tx : '';
    this.delirouteId = event ? event.data.delirouteId : 0;
    this.delirouteCd = event ? event.data.delirouteCd : '';
    this.typeshipinvoiceCd = event ? event.data.maTypeshipinvoiceCd : '';
    this.freeItem1Tx = event ? event.data.freeItem1Tx : '';
    this.freeItem2Tx = event ? event.data.freeItem2Tx : '';
    this.updcounterNr = event ? event.data.updcounterNr : 0;
    console.log(event);

    if (event) sessionStorage.setItem('wa9144_shiphId', event.data.shiphId);
  }

  onlynotapplied() {
    this.onSubmit();
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.searchOwnerId = selectedOwnerId;
      } else {
        this.searchOwnerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.gridOptions.api.deselectAll();
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.onFilterClear();
    const params: URLSearchParams = new URLSearchParams();
    if (this.searchOwnerId !== undefined) {
      params.set('ownerId', this.searchOwnerId.toString());
    }
    // if (this.checkbox) {
    params.set('dterrorFl', '1');
    // }
    this.shipService
      .get(params)
      .then(outputJson => {
        this.rowData = outputJson.ships;
        this.ships = outputJson.ships;
        this.working2 = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working2 = false;
      });
  }

  onCreate() {
    this.gridOptions.api.showLoadingOverlay();
    if (this.working3) return;
    this.working3 = true;
    
    this.isEnableCreateButton = true;
    if (this.dtaddressId == 0 || !this.dtaddressId) {
      this.errorInfo = '届先マスタが登録されていないため、修正できません';
      this.isEnableCreateButton = false;
      return;
    }
    console.log(this.shiphId,
      this.dtaddressId,
      this.dtaddressCd,
      this.dtnameTx,
      this.dtpostalCd,
      this.dtaddress1Tx,
      this.dtaddress2Tx,
      this.dtaddress3Tx,
      this.dttelTx,
      'wa9144');
    this.dtAddressService
      .put(
        this.ownerId,
        this.updcounterNr,
        this.dtaddressId,
        this.dtaddressCd,
        this.dtnameTx,
        this.dtpostalCd,
        this.dtaddress1Tx,
        this.dtaddress2Tx,
        this.dtaddress3Tx,
        '',
        this.dttelTx,
        this.carrierCd,
        this.delirouteId,
        this.delirouteCd,
        this.typeshipinvoiceCd,
        this.freeItem1Tx,
        this.freeItem2Tx,
        'wa9144'
      )
      .then(outputJson => {
        this.gridOptions.api.hideOverlay();
        this.dtAddressService
          .dterror(
            this.shiphId,
            this.dtaddressId,
            this.dtaddressCd,
            this.dtnameTx,
            this.dtpostalCd,
            this.dtaddress1Tx,
            this.dtaddress2Tx,
            this.dtaddress3Tx,
            this.dttelTx,
            'wa9144')
          .then(outputJson => {
            document.getElementById('otherwindow-dataarea').scrollTop = 0;
            // sessionStorage.setItem('SuccessInfoMessage', '完了,届先マスタ修正が完了しました');
            setTimeout(() => {
              this.cancel();
              this.onSubmit();
            }, 3200);
          })
          .catch(error => {
            this.gridOptions.api.hideOverlay();
            this.working3 = false;
            this.isEnableCreateButton = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
        this.working3 = false;
        this.isEnableCreateButton = false;
      })
      .catch(error => {
        this.working3 = false;
        this.isEnableCreateButton = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  oGridDetailButtonClick(event) {
    this.dspnone = false;
    this.otherwindow = true;
    this.NodeData = event.data;
    this.ownerId = event ? event.data.ownerId : 0;
    this.ownerTx = event ? event.data.ownerTx : 0;
    this.shiphId = event ? event.data.shiphId : 0;
    this.carrierCd = event ? event.data.maCarrierCd : '';
    this.dtaddressId = event ? event.data.maDtaddressId : 0;
    this.dtaddressCd = event ? event.data.dtaddressCd : '';
    this.dtnameTx = event ? event.data.dtnameTx : '';
    this.maDtnameTx = event ? event.data.maDtnameTx : '';
    this.dtpostalCd = event ? event.data.dtpostalCd : '';
    this.dttelTx = event ? event.data.dttelTx : '';
    this.dtaddress1Tx = event ? event.data.dtaddress1Tx : '';
    this.dtaddress2Tx = event ? event.data.dtaddress2Tx : '';
    this.dtaddress3Tx = event ? event.data.dtaddress3Tx : '';
    this.maDtpostalCd = event ? event.data.maDtpostalCd : '';
    this.maDttelTx = event ? event.data.maDttelTx : '';
    this.maDtaddress1Tx = event ? event.data.maDtaddress1Tx : '';
    this.maDtaddress2Tx = event ? event.data.maDtaddress2Tx : '';
    this.maDtaddress3Tx = event ? event.data.maDtaddress3Tx : '';
    this.delirouteId = event ? event.data.delirouteId : 0;
    this.delirouteCd = event ? event.data.delirouteCd : '';
    this.typeshipinvoiceCd = event ? event.data.maTypeshipinvoiceCd : '';
    this.freeItem1Tx = event ? event.data.freeItem1Tx : '';
    this.freeItem2Tx = event ? event.data.freeItem2Tx : '';
    this.updcounterNr = event ? event.data.updcounterNr : 0;
    this.isEnableCreateButton = true;
    //console.log('carrierCd:' + event.data.carrierCd + ', maCarrierCd:' + event.data.maCarrierCd);
    //console.log('typeshipinvoiceCd:' + event.data.typeshipinvoiceCd + ', maTypeshipinvoiceCd:' + event.data.maTypeshipinvoiceCd);
  }

  cancel() {
    document.getElementById('otherwindow-dataarea').scrollTop = 0;
    this.otherwindow = false;
    setTimeout(() => {
      this.dspnone = true;
    }, 500);

    this.errorInfo = '';
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9144/wa9144.component.ts